"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrapper = exports.ItemsPanel = exports.HomePageToggleWrapper = exports.CreditUsageWrapper = exports.Container = exports.BgOverlay = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));
var _uiKit = require("@icis/ui-kit");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Nav = require("../../../Nav.style");
var _sharedStyle = require("../../sharedStyle");
var _templateObject;
const {
  colours,
  media
} = _uiKit.theme;
const Wrapper = exports.Wrapper = _styledComponents.default.div.withConfig({
  displayName: "Mainstyle__Wrapper",
  componentId: "sc-4mjgo3-0"
})(["position:fixed;top:", "px;left:0;right:0;bottom:0;z-index:100;"], _sharedStyle.headerHeight);
const BgOverlay = exports.BgOverlay = _styledComponents.default.div.withConfig({
  displayName: "Mainstyle__BgOverlay",
  componentId: "sc-4mjgo3-1"
})(["position:fixed;top:", "px;left:0;right:0;bottom:0;background-color:", "80;"], _sharedStyle.headerHeight, colours.NEUTRALS_9);
const ItemsPanel = exports.ItemsPanel = _styledComponents.default.div.withConfig({
  displayName: "Mainstyle__ItemsPanel",
  componentId: "sc-4mjgo3-2"
})(["background-color:", ";position:relative;bottom:0;left:0;width:100vw;z-index:1;overflow:", ";", ""], colours.WHITE, _ref => {
  let {
    hasOverflow
  } = _ref;
  return hasOverflow ? 'hidden' : 'auto';
}, _Nav.mobileContainerDimension);
const CreditUsageWrapper = exports.CreditUsageWrapper = _styledComponents.default.div.withConfig({
  displayName: "Mainstyle__CreditUsageWrapper",
  componentId: "sc-4mjgo3-3"
})(["padding:20px 16px;position:relative;border-bottom:solid 1px ", ";cursor:pointer;a,span{text-decoration:none !important;}&:active{background-color:", ";div{color:", ";}}"], colours.NEUTRALS_5, colours.PRIMARY_1, colours.WHITE);
const HomePageToggleWrapper = exports.HomePageToggleWrapper = _styledComponents.default.div.withConfig({
  displayName: "Mainstyle__HomePageToggleWrapper",
  componentId: "sc-4mjgo3-4"
})(["display:flex;align-items:center;padding:20px 16px;position:relative;border-bottom:solid 1px ", ";height:60px;> div{width:100%;}label{width:100%;span{flex:1;display:flex;align-items:center;}}&:empty{display:none;}", ""], colours.NEUTRALS_5, media.md(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["display: none;"]))));
const Container = exports.Container = _styledComponents.default.div.withConfig({
  displayName: "Mainstyle__Container",
  componentId: "sc-4mjgo3-5"
})(["list-style:none;outline:none !important;padding-left:0;div{user-select:text;}"]);